import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

export default class Category {
    key: string;
    name: string;
    enabled: boolean;
    position: number | null;
    nameOriginal?: {
        text: string | null;
        lang: string;
    };

    constructor(
        key: string,
        name: string,
        enabled: boolean,
        position: number | null,
        nameOriginal?: { text: string | null; lang: string }
    ) {
        this.key = key;
        this.name = name;
        this.enabled = enabled;
        this.position = position;
        this.nameOriginal = nameOriginal;
    }

    public static readonly list = async (
        uuid: string,
        brand: string,
        duration?: number,
        sortedByPosition: boolean = false
    ) =>
        (
            await axios
                .get(environment.api_url + "/" + brand + "/category/list", {
                    headers: {
                        "User-Token": uuid,
                    },
                    params: duration ? { duration } : undefined,
                })
                .then((res) => (res.status === 200 ? res.data : undefined))
                .catch(console.error)
        )?.sort((a: Category, b: Category) =>
            sortedByPosition
                ? (a.position ?? Infinity) - (b.position ?? Infinity)
                : 0
        ) as Category[] | undefined;

    public static readonly count = async (
        uuid: string,
        brand: string,
        duration?: number
    ) =>
        (
            await axios
                .get(environment.api_url + "/" + brand + "/category/count", {
                    headers: {
                        "User-Token": uuid,
                    },
                    params: duration ? { duration } : undefined,
                })
                .then((res) => (res.status === 200 ? res.data : undefined))
                .catch(console.error)
        ).count as number | undefined;

    public static readonly update = async (
        uuid: string,
        brand: string,
        key: string,
        name: string,
        enabled: boolean,
        position: number | null
    ) =>
        axios.put(
            environment.api_url + "/" + brand + "/category/" + key,
            {
                name,
                enabled,
                position,
            },
            {
                headers: {
                    "User-Token": uuid,
                },
            }
        );

    public static readonly register = async (
        uuid: string,
        brand: string,
        name: string
    ) =>
        (
            await axios
                .post(
                    environment.api_url + "/" + brand + "/category",
                    {
                        name,
                        enabled: true,
                    },
                    {
                        headers: {
                            "User-Token": uuid,
                        },
                    }
                )
                .then((res) => res.data)
                .catch(console.error)
        )?.key as string | undefined;

    public static readonly delete = async (
        uuid: string,
        brand: string,
        key: string
    ) => {
        try {
            await axios.delete(
                `${environment.api_url}/${brand}/category/${key}`,
                {
                    headers: {
                        "User-Token": uuid,
                    },
                }
            );
            return true; // Indicates success
        } catch (error) {
            console.error("Failed to delete category:", error);
            return false; // Indicates failure
        }
    };
}
